import clsx from 'clsx';
import Link from 'next/link';
import Subheading, { SubheadingColourScheme } from 'components/Subheading';
import React from 'react';
import CardWithBackgroundImage from 'components/CardWithBackgroundImage';
import styles from './BlogArticleCard.module.css';

const BlogArticleCard = ({
  title,
  subheading,
  datePostedString,
  imageDirectory,
  href,
  backgroundPosition = 'center',
  target = '_self',
  style,
}) => {
  return (
    <Link
      href={href}
      target={target}
      className={clsx(
        'blogArticleCard',
        styles.blogArticleCard,
        styles.fullWidth,
        styles.flexCentered,
      )}
      style={style}
    >
      <CardWithBackgroundImage
        id="blogArticleCard"
        className={styles.blogArticleCardInner}
        imageDirectory={imageDirectory}
        imageFname="hero"
        imageOpacity="0.52"
      >
        <Subheading
          Tag="h4"
          className="blogArticleCardTitle"
          colourScheme={SubheadingColourScheme.WHITE_TEXT_BLACK_SHADOW}
        >
          {title}
        </Subheading>

        <div
          className="separator"
          style={{ alignSelf: 'center', margin: '0.6em', width: '85%' }}
        />

        <p>{subheading}</p>

        <p style={{ fontWeight: '600', justifySelf: 'flex-end' }}>
          {datePostedString}
        </p>
      </CardWithBackgroundImage>
      <style
      // A horrific global style, since we previously used styled jsx on a Link element, but this
      // no longer works in NextJS 16
      >
        {`
          .blogArticleCard .cardWithBackgroundImage {
            height: 100%;
            padding: 1.25em;
            border-radius: 4px;
          }

          .blogArticleCardTitle {
            /* font-size was in em before, which means it scaled relative to its parent's size */
            font-size: 15px !important
          }
          @media (min-width: 768px) {
            .blogArticleCardTitle {
              /* font-size was in em before, which means it scaled relative to its parent's size */
              font-size: 23px !important
            }
          }
        `}
      </style>
    </Link>
  );
};

export default BlogArticleCard;
